export default __webpack_public_path__ + "static/media/twitter.fada4277.svg";